import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import { Card, Input } from "antd";
import Pagination from "../components/Pagination"; // Ensure this path matches your project structure
import "./listings/Pages.css";

const DashboardLoginHistory = ({
  loginHistorySearchText,
  setLoginHistorySearchText,
}) => {
  const { loginHistory, status, error } = useSelector(
    (state) => state.groupData
  );

  // --- Pagination State ---
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Reset to page 1 when search text changes
  useEffect(() => {
    setCurrentPage(1);
  }, [loginHistorySearchText]);

  // 1. Filter the data first
  const filteredLoginHistory = loginHistory?.filter(
    (history) =>
      (history.staff_name || "")
        .toLowerCase()
        .includes(loginHistorySearchText.toLowerCase()) ||
      (history.staff_no || "")
        .toLowerCase()
        .includes(loginHistorySearchText.toLowerCase()) ||
      (history.mobile_number ? String(history.mobile_number) : "")
        .toLowerCase()
        .includes(loginHistorySearchText.toLowerCase())
  ) || [];

  // 2. Calculate Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredLoginHistory.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredLoginHistory.length / itemsPerPage);

  const onLoginHistorySearch = (value) => {
    setLoginHistorySearchText(value);
  };

  return (
    <Card className="recent-activities-card p-2 w-100 ms-2 responsive">
      <div
        className="py-3 px-4 w-100 d-flex justify-content-between align-items-center flex-wrap"
        style={{
          backgroundColor: "#f0f0f0",
          borderBottom: "1px solid #d9d9d9",
        }}
      >
        <h3 className="m-0 fw-600">Staff Login History</h3>
        <Input.Search
          placeholder="Search staff name, number, or mobile..."
          allowClear
          style={{ width: 250, marginTop: "8px" }}
          onSearch={onLoginHistorySearch}
          onChange={(e) => setLoginHistorySearchText(e.target.value)}
        />
      </div>
      
      <Table striped bordered hover responsive className="mb-0">
        <thead>
          <tr>
            <th className="login_history_heading">S.No</th>
            <th className="login_history_heading">Staff Name</th>
            <th className="login_history_heading">Staff No</th>
            <th className="login_history_heading">Mobile Number</th>
            <th className="login_history_heading">Type</th>
            <th className="login_history_heading">Login Time</th>
          </tr>
        </thead>
        <tbody>
          {status === "succeeded" && currentItems.length > 0 ? (
            currentItems.map((history, index) => (
              <tr key={history.id || index}>
                {/* Calculate continuous S.No based on page */}
                <td>{indexOfFirstItem + index + 1}</td>
                <td>{history.staff_name || "N/A"}</td>
                <td>{history.staff_no || "N/A"}</td>
                <td>{history.mobile_number || "N/A"}</td>
                <td>{history.type || "N/A"}</td>
                <td>
                  {history.create_at
                    ? new Date(history.create_at).toLocaleString()
                    : "N/A"}
                </td>
              </tr>
            ))
          ) : status === "loading" ? (
            <tr>
              <td colSpan="6" className="text-center">Loading...</td>
            </tr>
          ) : status === "failed" ? (
            <tr>
              <td colSpan="6" className="text-center text-danger">
                Error loading data: {error}
              </td>
            </tr>
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No login history found matching the search criteria.
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Pagination Footer */}
      {status === "succeeded" && filteredLoginHistory.length > 0 && (
        <div className="p-3 d-flex justify-content-end">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
    </Card>
  );
};

export default DashboardLoginHistory;